import { render, staticRenderFns } from "./DragUploadPanel.vue?vue&type=template&id=31861148&scoped=true&"
import script from "./DragUploadPanel.vue?vue&type=script&lang=js&"
export * from "./DragUploadPanel.vue?vue&type=script&lang=js&"
import style0 from "./DragUploadPanel.vue?vue&type=style&index=0&id=31861148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31861148",
  null
  
)

export default component.exports